import { Action } from 'redux';
import { ContractReviewState, ContractReviewUnloadState } from '../../states/ContractReview.States';
import ContractReviewListReducer from './ContractReview.List.Reducer';
import ContractReviewCreateReducer from './ContractReview.Create.Reducer';
import ContractReviewDetailReducer from './ContractReview.Detail.Reducer';
import ContractReviewDecisionReducer from './ContractReview.Decision.Reducer';
import ContractReviewApplyReducer from './ContractReview.Apply.Reducer';
import ContractReviewUndoReducer from './ContractReview.Undo.Reducer';

const reducers = [
  ContractReviewListReducer,
  ContractReviewCreateReducer,
  ContractReviewDetailReducer,
  ContractReviewDecisionReducer,
  ContractReviewApplyReducer,
  ContractReviewUndoReducer
];

/**
 * Como `reduceReducers`, pero arranca del estado inicial del slice: `reduceReducers` arranca de `{}` y los reducers
 * de este slice esperan colecciones inicializadas.
 */
export const CombinedContractReviewReducer = (state: ContractReviewState | undefined, action: Action): ContractReviewState =>
  reducers.reduce((acc, reducer) => reducer(acc, action), state ?? ContractReviewUnloadState);
